import React, { memo } from 'react';
import { node, bool, func } from 'prop-types';
import classnames from 'classnames';

import { Button } from '@material-ui/core';

import './Tab.scss';

const Tab = ({ children, selected = false, onClick }) => {
  const classes = classnames('Tab', {
    'Tab--selected': selected,
  });

  return (
    <Button className={classes} onClick={onClick}>
      {children}
    </Button>
  );
};

Tab.propTypes = {
  children: node,
  selected: bool,
  onClick: func,
};

export default memo(Tab);
